module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-right",
    attrs: {
      "id": "PANELRIGHT-SWF"
    }
  }, [(_vm.platform != 'qt') ? _c('div', {
    staticClass: "title"
  }) : _vm._e(), _vm._v(" "), (_vm.platform != 'qt') ? _c('div', {
    staticClass: "title_action"
  }, [_vm._v("动作")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-panel"
  }, _vm._l((_vm.tabs_data), function(item, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "panel-group"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('material')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('action')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('camera')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('euy-text')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('euy-audio')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('align')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('step')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('action-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('parts')], 1)]), _vm._v(" "), (_vm.platform == 'qt') ? _c('psocket', {
    attrs: {
      "attributes": _vm.attributes,
      "flashvars": _vm.flashvars
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65a09e46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PanelRight/PanelRight.vue
// module id = 395
// module chunks = 0